import { Keyword } from '../../../domain/models';

export function getHashForKeyword(keyword?: Keyword) {
	return keyword ? encodeURIComponent(keyword) : 'all';
}
